// Offer Bar Element
class OfferBar extends HTMLElement {
  constructor() {
    super();
    //this.addToCartButton = document.querySelector('.product-form__submit')
    //this.addToCartButton.setAttribute('disabled', 'disabled')
  }
  
  connectedCallback(){
    const progress = this.querySelector('[data-progress]')
    const progressPercentage = progress.getAttribute('data-progress')
    setTimeout(() => {
      progress.style.width = `${progressPercentage}%`
    }, 500);

    this.updateOfferBarOnQtyChange(progress)
  }

  updateOfferBarOnQtyChange(progressElement){
    const QTYs = document.querySelectorAll('.option_variant--plan .quantity__input')
    //let enableButton = false
    QTYs.forEach(QTY => {
      QTY.addEventListener('change', (e)=>{
        var total = 0
        QTYs.forEach(QTY => {
          total = total + parseInt(QTY.value);
        });
        console.log('total: ', total)

        var offerBlockMessage = this.closest('.product__offer-block').querySelector('.offer-block__message')
        var targetNumber = this.getAttribute('data-target')
        var remainNumber = targetNumber - total
        

        var message = this.getAttribute('data-message').replace("$", remainNumber);
        var congratsMessage = this.getAttribute('data-congrats-message')

        if (total >= targetNumber) {
          var progress_ratio = 100
          var text = congratsMessage
          //enableButton = true

        } else {
          var progress_ratio = (total / targetNumber) * 100
          var text = message
          //enableButton = false
        }
        setTimeout(() => {
          progressElement.style.width = `${progress_ratio}%`
          offerBlockMessage.innerText = text
          //!enableButton ? this.addToCartButton.setAttribute('disabled', 'disabled') : this.addToCartButton.removeAttribute('disabled')
        }, 500);
      })
    });
  }
}

customElements.define('offer-bar', OfferBar);

// Subscription widget option Element
class SubscribeOption extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input')
    this.selling_plan_inputs = document.querySelectorAll('input[selling-plan-input]')
    this.planVariants = document.querySelectorAll('.option_variant--plan')
    this.otVariants = document.querySelectorAll('.option_variant--ot')
    if (this.querySelector(`select[name="selling_plan"]`)) {
      this.frequency = this.querySelector(`select[name="selling_plan"]`)
      let freqMinimumQty = this.frequency.options[ this.frequency.selectedIndex ].getAttribute('data-minimum-qty');
      this.minQuantityToAdd = parseInt(freqMinimumQty)
    }
  }
  
  connectedCallback(){
    this.handleSuscription()
    this.input.addEventListener('change', (e)=>{
      this.handleSuscription()
    })

    if (this.frequency) {
      this.frequency.addEventListener('change', (e)=>{
        const freq_value = e.target.value;
        this.selling_plan_inputs.forEach(input => {
          input.value = freq_value;
        });
        this.minQuantityToAdd = parseInt(this.frequency.options[ this.frequency.selectedIndex ].getAttribute('data-minimum-qty'))
        this.handlingFrequencyInfo();
      })
    }
  }
  handleSuscription(){
    if (this.input.checked) {
      if (this.input.value == "subscribe") {
        this.selling_plan_inputs.forEach(input => {
          input.removeAttribute('disabled')
        });
        this.toggleVariant(this.planVariants)
        
      }else{
        this.selling_plan_inputs.forEach(input => {
          input.setAttribute('disabled', '')
        });
        this.toggleVariant(this.otVariants)
      }
    }
  }
  toggleVariant(activeVariants){
    let enable = this.planVariants, disable = this.otVariants
    activeVariants != this.planVariants && (enable = this.otVariants, disable = this.planVariants)
    disable.forEach(variant => {
      variant.style.display = 'none'
      variant.querySelectorAll('input').forEach(input=> input.setAttribute('disabled', ''))
    });
    enable.forEach(variant => {
      variant.style.display = 'block'
      variant.querySelectorAll('input').forEach(input=> input.removeAttribute('disabled'))
    });
  }
  
  handlingFrequencyInfo(){
    var originalPrice = this.querySelector(`[data-subscription-original-price]`);
    var discountedPrice = this.querySelector(`[data-subscription-discounted-price]`);
    var OriginalPriceValue = parseInt(originalPrice.getAttribute('data-value'))
    var discountedPriceValue = parseInt(discountedPrice.getAttribute('data-value'))

    var originalPriceFormated = Shopify.formatMoney(OriginalPriceValue * this.minQuantityToAdd, Shopify.money_format)
    var discountedPriceFormated = Shopify.formatMoney(discountedPriceValue * this.minQuantityToAdd, Shopify.money_format)
    
    originalPrice.innerText = originalPriceFormated
    discountedPrice.innerText = discountedPriceFormated
  }
}

customElements.define('subscribe-option', SubscribeOption);

// Product Card Variant Swatches
class CardVariantSwatch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input')
    this.card = this.closest('.card')
    // this.card_image = this.card.querySelector('.media img')
    this.card_links = this.card.querySelectorAll('a[card-link]')
    
    this.input.addEventListener('change', this.inputChanged.bind(this) )
  }

  connectedCallback(){
    this.clickEventsToTheCardParts()
  }
  
  inputChanged(){
    if (this.input.checked) {
      /*
        Getting the data from the checked input 
      */
      this.card_image = this.card.querySelector('.media img')

      const variant_url = this.input.getAttribute('data-var-url')
      const variant_image_src = this.input.getAttribute('data-var-img-src')
      const variant_image_srcset = this.input.getAttribute('data-var-img-srcset')
      const variant_image_alt = this.input.getAttribute('data-var-img-alt')

      /* 
        Setting the data of the checked input to the card parts 
      */
      
      // Update Image

      // Create new Image Element with the new Srs and Srcset
      let newImage = document.createElement("img");
      newImage.className = 'motion-reduce';
      newImage.setAttribute('src', variant_image_src);
      newImage.setAttribute('srcset', variant_image_srcset);
      newImage.setAttribute('alt', variant_image_alt);
      newImage.setAttribute('sizes', this.card_image.getAttribute('sizes'));
      newImage.setAttribute('width', '1000');
      newImage.setAttribute('height', '1000');

      this.card_image.replaceWith(newImage)

      // Update Links
      this.card_links.forEach(link => {
        link.href = variant_url
      });

    }
  }

  clickEventsToTheCardParts(){
    return
    // this.card.querySelector('.card__content').addEventListener('click', (e)=>{
    //   this.card.querySelector('.card__heading a').click()
    // })
    
    // if (this.card.querySelector('.card__variant-swatch--extra-colors')) {
    //   this.card.querySelector('.card__variant-swatch--extra-colors').addEventListener('click', (e)=>{
    //     this.card.querySelector('.card__heading a').click()
    //   })
    // }
  }
}
customElements.define('card-variant-swatch', CardVariantSwatch);
